import { render, staticRenderFns } from "./mangerAwardDetail.vue?vue&type=template&id=1c369e9e&"
import script from "./mangerAwardDetail.vue?vue&type=script&lang=js&"
export * from "./mangerAwardDetail.vue?vue&type=script&lang=js&"
import style0 from "./mangerAwardDetail.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports